import { useRef, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DescriptionOutlined } from '@mui/icons-material';
import { CalendarDateService } from '@uplift/services';

import { ReferralPopover } from '../ReferralPopover';
import { StudentsTableColumnRenderArgs } from '../types';

export type ReferralCellProps = StudentsTableColumnRenderArgs<'referral'> & { isCareApp: boolean };

export const ReferralCell: React.VFC<ReferralCellProps> = ({ row, isCareApp }) => {
  const [ open, setOpen ] = useState(false);
  const ref = useRef<HTMLElement>(null);
  const { classes, cx } = useReferralCellStyles();
  const createdDate = CalendarDateService.date(row?.referral).format('MM/DD/YYYY');

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
      {isCareApp && (
        <Box className={cx(classes.iconBox, open && classes.iconBoxHighlight)}>
          <DescriptionOutlined
            onClick={() => setOpen(!open)}
            className={classes.icon}
            ref={ref as unknown as React.MutableRefObject<SVGSVGElement | null>}
            data-testid="students-table-referral-icon"
          />
        </Box>
      )}
      {open && <ReferralPopover {...row} onClose={() => setOpen(false)} anchorEl={ref.current ?? undefined} />}
      <Box display="flex" p={2}>
        <Typography variant="body2" className={classes.date} data-testid="students-table-referral-date">
          {createdDate}
        </Typography>
      </Box>
    </Box>
  );
};

const useReferralCellStyles = makeStyles({ name: 'ReferralCell' })((theme) => ({
  iconBox: {
    display: 'flex',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    borderRadius: '50%',
    gridGap: '10px',
  },
  iconBoxHighlight: {
    backgroundColor: theme.palette.grey[100],
  },
  icon: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  date: {
    color: theme.palette.text.primary,
    letterSpacing: '0.4px',
    fontWeight: 400,
  },
}));
